import React from 'react'
export default function SectionTitle  ({text}) {
  return (
    <div className="font-vol uppercase  font-italic text-2xl lg:text-4xl my-4 mlg:my-8 text-center tracking-widest">{text}</div>
  )
}